import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ChangeOrderIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.44 19V6.52L3.12 9.92L2.04 8.88L7.32 3.6L12.6 8.88L11.52 9.92L8.2 6.52V19H6.44ZM12.48 14L15.8 17.4V4.92H17.56V17.4L20.88 14L21.96 15.04L16.68 20.32L11.4 15.04L12.48 14Z" />
    </SvgIcon>
  );
});
